export enum ThemeElementType {
    EMERGE = 'EMERGE',
    SQUAREONE = 'SQUAREONE',
    VASTBANK = 'VAST_BANK'
}